import React from "react";
import ReactDOM from "react-dom";

interface MenuButtonsPortalProps {
  children: React.ReactNode;
}

const MenuButtonsPortal: React.FC<MenuButtonsPortalProps> = ({ children }) => {
  const element = document.getElementById("header-bottom-right-container");
  return element ? ReactDOM.createPortal(children, element) : null;
};

export default MenuButtonsPortal;
